<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            :width="1000"
            :footer-hide="true"
            title="搜素">
            <search-card :form="mainTable.searchForm "
                :table-load-event="getDiscardTableRecord"
                :table-search="mainTable.tableSearch" />
        </Modal>
        <Modal v-model="show"
            :width="70"
            :footer-hide="true"
            title="报损记录"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">报损单列表</span>
                        </div>
                        <div class="right-bar">
                            <Button v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateDiscard">新增</Button>
                            <Button type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                :loading="btnLoading"
                                @click="onExport()">导出</Button>
                            <Button type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        </div>
                    </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                    <stand-pagination-table :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :extHeight="100"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getDiscardTableRecord" />
                    </Col>
                </Row>
            </Card>
        </Modal>

        <CurSaleWarehouseDiscardEdit ref="curSaleWarehouseDiscardEditModal" />
        <CurSaleWarehouseDiscardDetail ref="curSaleWarehouseDiscardDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateRender } from '@/libs/tableRowTimeRender';
import CurSaleWarehouseDiscardEdit from './curSale-warehouse-discard-edit';
import CurSaleWarehouseDiscardDetail from './curSale-warehouse-discard-detail';
import { getCurSaleDiscardList, exportCurSaleDiscardList } from '@/api/modules/warehouse-management/warehouse';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'CurSaleWarehouseDiscardList',
    components: {
        SearchCard,
        StandPaginationTable,
        CurSaleWarehouseDiscardEdit,
        CurSaleWarehouseDiscardDetail
    },
    data() {
        return {
            show: false,
            btnLoading: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '单号', key: 'curSaleWarehouseStoreDiscardRecordBillCode', align: 'center' },
                    { title: '制单人', key: 'userPersonName', align: 'center' },
                    { title: '备注', key: 'curSaleWarehouseStoreDiscardRecordRemark', align: 'center' },
                    { title: '制单日期', key: 'curSaleWarehouseStoreDiscardRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleWarehouseStoreDiscardRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.curSaleWarehouseDiscardDetailModal.showModal(params.row.curSaleWarehouseStoreDiscardRecordUuid);
                                            // this.$router.push({
                                            //     name: 'cur-sale-warehouse-discard-detail',
                                            //     query: {
                                            //         curSaleWarehouseStoreDiscardRecordUuid: params.row.curSaleWarehouseStoreDiscardRecordUuid
                                            //     }
                                            // });
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '单号', type: 'Input', value: '', name: 'curSaleWarehouseStoreDiscardRecordBillCode', sql: 'like' },
                    { label: '制单人', type: 'Input', value: '', name: 'userPersonName', sql: 'like' },
                    { label: '制单日期', type: 'Daterange', value: '', name: 'curSaleWarehouseStoreDiscardRecordCreateAt', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        onExport() {
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            exportCurSaleDiscardList(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                }
            });
        },
        init() {
            this.getDiscardTableRecord();
        },
        getDiscardTableRecord(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getCurSaleDiscardList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateDiscard() {
            this.$refs.curSaleWarehouseDiscardEditModal.showModal();
            // this.$router.push({ name: 'cur-sale-warehouse-discard-edit' });
        }
    }
};
</script>

<style scoped>
</style>
